import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

const DeleteFeed = (props) => {
    // const submit = props.submit
    const getData = props.getData
    const modal2 = props.modal2
    const setModal2 = props.setModal2
    const id = props.id

    const cancelDelete = (e) => {
        e.preventDefault();
        setModal2(!modal2)
    }

    const submitData = (e) => {
        e.preventDefault()

        let data = axios.delete(`/api/feeds/feed/${id}`, { data: { ids: [id] },
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            }
        })
            .then(response => {
                showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
                getData()
            })
            .catch(error => {
                
                console.error('Error making POST request:', error);
                showErrorToast("Error")
            });
        setModal2(!modal2)

    }



    return (
        <div>
            <Modal size="md" isOpen={modal2} toggle={() => setModal2(!modal2)}>
                <ModalHeader toggle={() => setModal2(!modal2)}>Delete Feed</ModalHeader>
                <ModalBody>
                <div className="d-flex justify-content-center">
                <p class="font-weight-bold">Are you sure you want to delete the feed?</p>
                </div>
                <div className="d-flex justify-content-center">
                <button color="secondary" class="btn btn-secondary m-4" onClick={(e) => cancelDelete(e)}> Cancel </button>
                <button class="btn btn-primary m-4" onClick={(e) => submitData(e)}> Delete </button>
                </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DeleteFeed;
